import { render, staticRenderFns } from "./Widget9.vue?vue&type=template&id=7983de1e&scoped=true"
import script from "./Widget9.vue?vue&type=script&lang=js"
export * from "./Widget9.vue?vue&type=script&lang=js"
import style0 from "./Widget9.vue?vue&type=style&index=0&id=7983de1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983de1e",
  null
  
)

export default component.exports